var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.buttonsColumnEdit')
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.editButtonsColumn
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.editAction')))])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.customClass')
    }
  }, [_c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": ""
    },
    model: {
      value: (_vm.optionModel.customClass),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "customClass", $$v)
      },
      expression: "optionModel.customClass"
    }
  }, _vm._l((_vm.cssClassList), function(item, idx) {
    return _c('el-option', {
      key: idx,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.showButtonsEditDialog) ? _c('el-dialog', {
    directives: [{
      name: "dialog-drag",
      rawName: "v-dialog-drag"
    }],
    attrs: {
      "title": _vm.i18nt('designer.setting.groupButtonsEdit'),
      "visible": _vm.showButtonsEditDialog,
      "show-close": true,
      "custom-class": "drag-dialog small-padding-dialog",
      "append-to-body": "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "destroy-on-close": true,
      "width": "1120px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showButtonsEditDialog = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "dialog-footer"
        }, [_c('el-button', {
          attrs: {
            "size": "default"
          },
          on: {
            "click": function($event) {
              _vm.showButtonsEditDialog = false
            }
          }
        }, [_vm._v(_vm._s(_vm.i18nt('designer.hint.closePreview')))])], 1)]
      },
      proxy: true
    }], null, false, 982766054)
  }, [_c('el-form', {
    attrs: {
      "label-position": "top",
      "model": _vm.optionModel
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-divider', {
    attrs: {
      "content-position": "left"
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.operationButtonsSetting')))])], 1)], 1), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "tag": "div",
      "list": _vm.optionModel.buttons
    }
  }, 'draggable', {
    ghostClass: 'ghost',
    handle: '.drag-handler'
  }, false), _vm._l((_vm.optionModel.buttons), function(btn, bIdx) {
    return _c('el-row', {
      key: bIdx,
      staticClass: "button-row",
      attrs: {
        "gutter": 8
      }
    }, [_c('el-col', {
      staticClass: "drag-sort-col",
      attrs: {
        "span": 1
      }
    }, [_c('i', {
      staticClass: "iconfont icon-drag drag-handler"
    })]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.name',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonName'),
        "rules": _vm.nameRules
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonName')
      },
      on: {
        "focus": _vm.onButtonNameFocus,
        "change": function (value) { return _vm.onButtonNameChange(value, bIdx); }
      },
      model: {
        value: (btn.name),
        callback: function($$v) {
          _vm.$set(btn, "name", $$v)
        },
        expression: "btn.name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.label',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonLabel')
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonLabel')
      },
      model: {
        value: (btn.label),
        callback: function($$v) {
          _vm.$set(btn, "label", $$v)
        },
        expression: "btn.label"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.type',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonType')
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": _vm.i18nt('designer.setting.operationButtonType')
      },
      model: {
        value: (btn.type),
        callback: function($$v) {
          _vm.$set(btn, "type", $$v)
        },
        expression: "btn.type"
      }
    }, [_c('el-option', {
      attrs: {
        "value": ""
      }
    }, [_vm._v("default")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "text"
      }
    }, [_vm._v("text")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "primary"
      }
    }, [_vm._v("primary")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "success"
      }
    }, [_vm._v("success")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "warning"
      }
    }, [_vm._v("warning")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "danger"
      }
    }, [_vm._v("danger")]), _vm._v(" "), _c('el-option', {
      attrs: {
        "value": "info"
      }
    }, [_vm._v("info")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 5
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.icon',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.buttonIcon')
      }
    }, [_c('icon-picker', {
      model: {
        value: (btn.icon),
        callback: function($$v) {
          _vm.$set(btn, "icon", $$v)
        },
        expression: "btn.icon"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.round',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonRound')
      }
    }, [_c('el-switch', {
      model: {
        value: (btn.round),
        callback: function($$v) {
          _vm.$set(btn, "round", $$v)
        },
        expression: "btn.round"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.hidden',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonHidden')
      }
    }, [_c('el-switch', {
      model: {
        value: (btn.hidden),
        callback: function($$v) {
          _vm.$set(btn, "hidden", $$v)
        },
        expression: "btn.hidden"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": 'buttons.' + bIdx + '.disabled',
        "label-width": "50px",
        "label": _vm.i18nt('designer.setting.operationButtonDisabled')
      }
    }, [_c('el-switch', {
      model: {
        value: (btn.disabled),
        callback: function($$v) {
          _vm.$set(btn, "disabled", $$v)
        },
        expression: "btn.disabled"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 1
      }
    }, [_c('el-button', {
      attrs: {
        "icon": "el-icon-delete",
        "plain": "",
        "circle": ""
      },
      on: {
        "click": function($event) {
          return _vm.deleteGroupButton(bIdx)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small",
      "icon": "el-icon-plus",
      "plain": "",
      "round": ""
    },
    on: {
      "click": _vm.addGroupButton
    }
  }, [_vm._v(_vm._s(_vm.i18nt('designer.setting.addOperationButton')))])], 1)], 1)], 1)], 1) : _vm._e()], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b25e237","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-button-group/button-group-customClass-editor.vue
// module id = null
// module chunks = 